module.exports={
	"Form": "BidItemEditManifest",
	"Scope": "BidItem-Edit",
	"Descriptors":
	{
		"BidItemDetails.Name":
		{
			"Name": "Name",
			"Hash": "BidItem-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "BidItem-Edit-Identity",
				"Group": "BidItem-Edit-Identity"
			}
		},
		"BidItemDetails.Description":
		{
			"Name": "Description",
			"Hash": "BidItem-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.Quantity":
		{
			"Name": "Quantity",
			"Hash": "BidItem-Edit-Quantity",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.Units":
		{
			"Name": "Units",
			"Hash": "BidItem-Edit-Units",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.CostPerUnit":
		{
			"Name": "Cost Per Unit",
			"Hash": "BidItem-Edit-CostPerUnit",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details"
			}
		},
		"BidItemDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "BidItem-Edit-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				]
			}
		},
		"BidItemDetails.IDProject":
		{
			"Name": "Project",
			"Hash": "BidItem-Edit-IDProject",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Project",
				"SearchFields":
				[
					"Name",
					"Description",
					"PurchaseOrderNumber",
					"ImprovementTypeCode"
				]
			}
		},
		"BidItemDetails.IDPayItem":
		{
			"Name": "Pay Item",
			"Hash": "BidItem-Edit-IDPayItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "PayItem",
				"SearchFields":
				[
					"Description",
					"ItemCode",
					"Name"
				]
			}
		},
		"BidItemDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "BidItem-Edit-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "BidItem-Edit-Details",
				"Group": "BidItem-Edit-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"BidItemDetails.IDBidItem":
		{
			"Name": "IDBid Item",
			"Hash": "BidItem-Edit-IDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.GUIDBidItem":
		{
			"Name": "GUIDBid Item",
			"Hash": "BidItem-Edit-GUIDBidItem",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "BidItem-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "BidItem-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "BidItem-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		},
		"BidItemDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "BidItem-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "BidItem-Edit-DataAudit",
				"Group": "BidItem-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "BidItem-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "BidItem-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "BidItem-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "BidItem-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "BidItem-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "BidItem-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
